/* tslint:disable */
/* eslint-disable */
/**
 * Survey API
 * API for managing Surveys and Questions.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePossibleAnswerCommand
 */
export interface UpdatePossibleAnswerCommand {
    /**
     * Answer key/code
     * @type {string}
     * @memberof UpdatePossibleAnswerCommand
     */
    key: string;
    /**
     * Answer label/text
     * @type {string}
     * @memberof UpdatePossibleAnswerCommand
     */
    label: string;
    /**
     * Type of value for this answer
     * @type {string}
     * @memberof UpdatePossibleAnswerCommand
     */
    valueType: string;
    /**
     * Display order of the answer
     * @type {number}
     * @memberof UpdatePossibleAnswerCommand
     */
    displayOrder: number;
    /**
     * Icon key for the answer
     * @type {string}
     * @memberof UpdatePossibleAnswerCommand
     */
    iconKey?: string | null;
    /**
     * Whether this answer has child answers
     * @type {boolean}
     * @memberof UpdatePossibleAnswerCommand
     */
    hasChildren?: boolean;
    /**
     * Additional data for the answer value
     * @type {object}
     * @memberof UpdatePossibleAnswerCommand
     */
    valueData?: object | null;
}

/**
 * Check if a given object implements the UpdatePossibleAnswerCommand interface.
 */
export function instanceOfUpdatePossibleAnswerCommand(value: object): value is UpdatePossibleAnswerCommand {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('valueType' in value) || value['valueType'] === undefined) return false;
    if (!('displayOrder' in value) || value['displayOrder'] === undefined) return false;
    return true;
}

export function UpdatePossibleAnswerCommandFromJSON(json: any): UpdatePossibleAnswerCommand {
    return UpdatePossibleAnswerCommandFromJSONTyped(json, false);
}

export function UpdatePossibleAnswerCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePossibleAnswerCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'label': json['label'],
        'valueType': json['valueType'],
        'displayOrder': json['displayOrder'],
        'iconKey': json['iconKey'] == null ? undefined : json['iconKey'],
        'hasChildren': json['hasChildren'] == null ? undefined : json['hasChildren'],
        'valueData': json['valueData'] == null ? undefined : json['valueData'],
    };
}

export function UpdatePossibleAnswerCommandToJSON(json: any): UpdatePossibleAnswerCommand {
    return UpdatePossibleAnswerCommandToJSONTyped(json, false);
}

export function UpdatePossibleAnswerCommandToJSONTyped(value?: UpdatePossibleAnswerCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'label': value['label'],
        'valueType': value['valueType'],
        'displayOrder': value['displayOrder'],
        'iconKey': value['iconKey'],
        'hasChildren': value['hasChildren'],
        'valueData': value['valueData'],
    };
}

